<template>
  <div class="onorder--tab">
    <b-row class="grid-header">
      <b-col>
        <div class="pull-right tools">
          <b-button
            v-if="checkClaim(CAN_EDIT_POS) && !hideActions"
            size="sm"
            variant="primary"
            :disabled="checkedRowItemIds.length === 0"
            @click="onAddToSources()">
            Post to Source
          </b-button>
        </div>
      </b-col>
    </b-row>
    <!-- TODO: Implement sorting in other areas such as sub-tabs -->
    <grid-component
        isResizable
        isReorderable
        :isSortable="isLinesFiltered"
        :canEdit="checkClaim(CAN_EDIT_POS)"
        :canDelete="checkClaim(CAN_DELETE_POS)"
        :gridId="gridId"
        :itemData="itemData"
        :fields="onOrderGridIdField"
        :onEdit="pushToDetails"
        :onDelete="onDelete"
        :sortBy="(isLinesFiltered) ? filterInfo.sortBy : null"
        :sortOrder="(isLinesFiltered) ? filterInfo.sortOrder : null"
        :sortMethod="(isLinesFiltered) ? sortPOLine : null"
        :handleRowClick="onRowClick"
        :navigationField="'purchaseOrderId'"
        :styleCustom="(itemData.length > 0) ? 'height: 160px' : ''"
        @checkedItem="checkedRowItemIds=$event"
      />
</div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { debounce, unionBy } from 'lodash';
import { GRID_PAGE_SIZES, PAGE_SIZE, GRID_ID, SEARCH_DEBOUNCE_TIME } from '@/shared/constants';
import { sortChange, prepareColumnsData } from '@/shared/helpers';
import GridSettings from '@/shared/components/GridSettings';
import GridComponent from '@/shared/components/GridComponent';
import gridFields from './fields';
import { addSourceOnOrderFields } from './fields';

export default {
  components: {
    GridSettings,
    GridComponent
  },
  props: {
    isPOTab: {
      type: Boolean,
      default: false,
    },
    partId: {
      type: [Number, String],
      default: 0,
    },
    hideEdit: {
      type: Boolean,
      default: false,
    },
    isFilteredList: {
      type: Boolean,
      default: false,
    },
    purchaseOrdersFiltered: {
      type: Array,
      default: () => [],
    },
    crfqLineId: [Number, String],
    isAvailableParts: {
      type: Boolean,
      default: false
    },
    salesOrderLineId: {
      type: [Number, String],
      default: 0
    },
    purchaseOrderLineId: {
      type: [Number, String],
      default: 0
    },
    gridId: {
      type: String,
      default: GRID_ID.ON_ORDER_LINES
    },
    onOrderFilter: {
      type: Object,
      default: null
    },
    isLinesFiltered: {
      type: Boolean,
      default: false
    },
    hideActions: {
      type: Boolean,
      default: false
    },
    quoteLineId: {
      type: [Number, String],
      default: 0
    },
    isQuoteLineView: [Boolean],
    isSalesOrderLineView: [Boolean]
  },
  data() {
    return {
      prepareColumnsData,
      pageNumber: 1,
      skip: 0,
      take: PAGE_SIZE,
      filtersVisible: false,
      fields: gridFields,
      pageable: {
        pageSizes: GRID_PAGE_SIZES,
      },
      selectedRowItemId: 0,
      checkedRowItemIds: [],
      checkedRowItemsObjArr: [],
      currentParams: {
        partId: 0,
        companyId: 0,
      },
      sourceFields: addSourceOnOrderFields
    };
  },
  computed: {
    ...mapGetters('purchaseorders', [
      'purchaseOrderLines',
      //'purchaseorders',
      //'pageInfo',
      //'sortBy',
      //'sortOrder',
      //'searchQuery',
      //'selectedItemId',
    ]),
    ...mapGetters('account', ['gridSettingsById']),
    ...mapGetters('purchaseOrderLines', ['filterInfo', 'linesFiltered']),
    gridSettings() {
      return this.gridSettingsById(this.gridId);
    },
    itemData() {
      let itemData = (this.isFilteredList) ? this.purchaseOrdersFiltered : (this.isLinesFiltered) ? this.linesFiltered : this.purchaseOrderLines;
      return itemData.map((purchaseorder) => ({ ...purchaseorder, selected: purchaseorder.id === this.selectedRowItemId }));
    },
    onOrderGridIdField() {
      return this.gridId == GRID_ID.ON_ORDER_SOURCES ? this.sourceFields : this.fields;
    }
  },
  methods: {
    ...mapActions('purchaseorders', [
        'getAll',
        //'sort',
        //'getPage',
        //'search',
        'select',
        'getByParts',
        'getOrdersByAvailablePart',
        'getOrdersBySalesOrderLine',
        'getOrdersByPurchaseOrderLine',
      ]),
    ...mapActions('requirements',['addToSources']),
    ...mapActions('purchaseOrderLines',['deletePurchaseOrderLine', 'getPurchaseOrderLinesFiltered', 'sortPOLine']),
    ...mapActions('quoteLineSources', {addQuoteLineSource: 'addSources'}),
    ...mapActions('salesOrderLineSources', {addSalesOrderLineSource: 'addSources'}),
    //...mapMutations('purchaseorders', ['clearPurchaseOrdersItems']),
    ...mapActions('account', ['saveGridSettings']),
    async onAddToSources() {
      this.$snotify.info('Posting On Order to Source', 'Sources');
      if (this.isQuoteLineView) {
        this.addQuoteLineSource(this.checkedRowItemsObjArr).then(() => {
          this.clearChecked();
          this.$snotify.success('Posted On Order to Source', 'Sources');
        });
      } else if (this.isSalesOrderLineView) {
        this.addSalesOrderLineSource(this.checkedRowItemsObjArr).then(() => {
          this.clearChecked();
          this.$snotify.success('Posted On Order to Source', 'Sources');
        });
      } else {
        this.addToSources(this.checkedRowItemsObjArr).then(() => {
          this.clearChecked();
          this.$snotify.success('Posted On Order to Source', 'Sources');
        });
      }
    },
    clearChecked() {
      this.checkedRowItemsObjArr = this.checkedRowItemIds = [];
    },
    handleSortChange({ sort }) {
      sortChange({
        sortBy: this.sortBy,
        sortData: sort,
        gridId: this.gridId,
        saveGridSettings: this.saveGridSettings,
      });
    },
    onRowClick(row) {
      this.selectedRowItemId = row.dataItem.id;
      this.$emit('selectedSourceObj', row.dataItem);
    },
    pushToDetails(row) {
      this.$router.push({
        name: 'purchaseorders.edit',
        params: { id: row.purchaseOrderId },
      });
    },
    async onDelete(item) {
      const deleteConfirmed = await this.openConfirmBox({message: `Are you sure you want to delete purchase order line with id :${item.id}?`});
      if (deleteConfirmed) {
        const result = await this.deletePurchaseOrderLine(item);
        if (this.partId) {
          if (this.isAvailableParts) {
            await this.getOrdersByAvailablePart(this.partId);
          } else {
            await this.getByParts(this.partId);
          }
        } else if (this.salesOrderLineId) {
          await this.getOrdersBySalesOrderLine(this.salesOrderLineId);
        } else if (this.purchaseOrderLineId) {
          await this.getOrdersByPurchaseOrderLine(this.purchaseOrderLineId);
        }

        this.$emit('updated');
      }
    }
  },
  watch: {
    purchaseOrderLines() {
      //This function sets the first row as the selected row
      // if(this.purchaseOrderLines.length > 0 && this.selectedRowItemId === 0){
      //   this.selectedRowItemId = this.purchaseOrderLines[0].id;
      //   const { id, detailsVisible } = this.purchaseOrderLines[0];
      //   this.select({ id, isChecked: !detailsVisible });
      //   this.$emit('selectedSourceObj', this.purchaseOrderLines[0]);
      // }
    },
    checkedRowItemIds() {
      const filteredObjArr = this.itemData.filter((obj) => this.checkedRowItemIds.includes(obj.id));

      this.checkedRowItemsObjArr = filteredObjArr.map(({ id, quantity, partId, cost, active }) => {
        const formattedQuantity = quantity || 0;
        const formattedCost = cost || 0;

        return {
          id: 0,
          requirementLineId: this.crfqLineId,
          quoteLineId: this.quoteLineId,
          salesOrderLineId: this.salesOrderLineId,
          purchaseOrderLineId: id,
          quantity: formattedQuantity,
          partId,
          cost: formattedCost,
          active,
        };
      });
    },
    async partId() {
      if (this.isAvailableParts) {
        await this.getOrdersByAvailablePart(this.partId);
      } else {
        await this.getByParts(this.partId);
      }
    },
    async salesOrderLineId() {
      await this.getOrdersBySalesOrderLine(this.salesOrderLineId);
    },
    async purchaseOrderLineId() {
      console.log(this.purchaseOrderLineId, "purchase order")
      await this.getOrdersByPurchaseOrderLine(this.purchaseOrderLineId);
    },
    onOrderFilter: {
      async handler() {
        this.$emit('searching', true);
        await this.getPurchaseOrderLinesFiltered(this.onOrderFilter).then(() => this.$emit('searching', false));
      },
      deep: true,
    },
  },
  mounted() {
    // this.clearPurchaseOrdersItems();
    if (!this.isFilteredList) {
      console.log('in if',this.isPOTab);
      if (!this.isPOTab) {
        this.getAll({});
      } else {
        // Removed pagination if by tab, go with Watch paramsOBJ (This is temporary...)
        this.pageable = false;
      }
    }else{
      console.log('in else');
    }
  },
  beforeDestroy() {
    this.select({ id: null, isChecked: false });
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_colors.scss';

.onorder--tab {
    .grid-header {
      margin-bottom: 5px;
  }
}
</style>
